import React from "react"

// Components
import Logo from "./svg/logo"

// Markup
const Menu = ({ styleClass, color }) => {

  return (
    <button className={`${styleClass}`}>
      <Logo color={color} styleClass="menu-logo" />
      <p style={{color: color}}>
        <span className="btn-open">menu</span>
        <span className="btn-close hidden">close</span>
      </p>
    </button>
  )
}
export default Menu
